var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"rating"},_vm._l((_vm.createRange(_vm.total)),function(star){return _c('li',{key:star,staticStyle:{"list-style-type":"none"}},[_c('i',{staticClass:"starColour fas fa-star"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }